/**
 *
 * @module sessionClientEndpoint
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef SessionClientEndpoint
 * @type {Object}
 *
 * @property {String} getLocation
 * @property {String} getInfo
 *
 */

/**
 *
 * @enum
 * @type {SessionClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    getInfo: null
});



// WEBPACK FOOTER //
// ./src/services/session/sessionClientEndpoint.js